import { render, staticRenderFns } from "./AccountHistoryMotorcheck.vue?vue&type=template&id=90c24ab4&scoped=true&"
import script from "./AccountHistoryMotorcheck.vue?vue&type=script&lang=js&"
export * from "./AccountHistoryMotorcheck.vue?vue&type=script&lang=js&"
import style0 from "./AccountHistoryMotorcheck.vue?vue&type=style&index=0&id=90c24ab4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c24ab4",
  null
  
)

export default component.exports